import React from 'react';
import PropTypes from 'prop-types';

const TransactionDriverCarRenderer = (props) => {
  const drivers = props.data.driver_trans

  return (
    <ul>
      {drivers && drivers.map((item, index) => (
        <li key={index} className="tw-pb-0 tw-mb-0">{item.driver?.name} <span className="tw-text-blue-600">({item.car?.name})</span></li>
      ))}
    </ul>
  );
};

TransactionDriverCarRenderer.propTypes = {
  data: PropTypes.shape({
    driver_trans: PropTypes.arrayOf(
      PropTypes.shape({
        driver: PropTypes.shape({ name: PropTypes.string }),
        car: PropTypes.shape({ name: PropTypes.string })
      })
    )
  }).isRequired
};

export default TransactionDriverCarRenderer;
